import ClockIcon from './ClockIcon'

export default ClockIcon
